var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"py-8 px-6 pl-12",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('p',{staticClass:"cont-title"},[_vm._v("도움말")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }